import React, { useContext } from "react";
import Footer from "../components/Footer";
import { NavLink, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Slider from "react-slick";
import axios from "axios";
import { useTranslation } from "react-i18next";

import Global from "../util/Global";
import { LoaderContext } from "../util/Loader";
import { DeliveryCountryContext } from "../components/Utils";




const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
};


const ENTREPRISE_URL = Global.backend + "/index.php/home/entreprises";
const nbOrders_URL = Global.backend + "/index.php/home/nombredecommande";
const nbBuyer_URL = Global.backend + "/index.php/home/nbBuyer";
const nbPays_URL = Global.backend + "/index.php/home/nombrepays";
const PRODUCT_URL = Global.backend + "/index.php/produit/showall";


const CustomArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#ca8d42",
        borderRadius: "50%",
        width: "3rem",
        height: "3rem",
        zIndex: 1,
      }}
      onClick={onClick}
    >
    </div>
  )
}



const Home = () => {
  const { t } = useTranslation();
  const [isInit, setisInit] = useState(false)
  const { isLoading, setisLoading } = useContext(LoaderContext)
  const { deliveryCountry } = useContext(DeliveryCountryContext)

  const [nbRegisteredCountries, setnbRegisteredCountries] = useState(0)
  const [nbRegisteredBusiness, setnbRegisteredBusiness] = useState(0)
  const [nbRegisteredBuyers, setnbRegisteredBuyers] = useState(0)
  const [nbOrders, setnbOrders] = useState(0)
  const [entrepriseList, setEntrepriseList] = useState([]);
  const [products, setproducts] = useState([])
  const navigate = useNavigate()


  useEffect(() => {
    setisLoading(true)
    setisInit(true)


    axios.all([
      axios.get(ENTREPRISE_URL),
      axios.get(nbPays_URL),
      axios.get(nbOrders_URL),
      axios.get(nbBuyer_URL),
      axios.post(PRODUCT_URL, { deliveryCountry })
    ])
      .then(axios.spread((entrepriseResponse, nbPaysResponse, nbOrdersResponse, nbBuyerResponse, productsResponse) => {
        setnbRegisteredCountries(nbPaysResponse.data[0].pays)
        setnbRegisteredBusiness(entrepriseResponse.data.length)
        setnbRegisteredBuyers(nbBuyerResponse.data)
        setnbOrders(nbOrdersResponse.data[0].count)
        setEntrepriseList(entrepriseResponse.data)
        setproducts(productsResponse.data)
      })).catch((err) => {

      })
      .finally(() => {
        setisLoading(false)
        setisInit(true)
      })

  }, [])




  const handleClickPrev = () => {
    slider.slickPrev();
  };

  const handleClickNext = () => {
    slider.slickNext();
  };

  let slider;



  const config = {

    centerMode: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,

  };



  if (!isInit) {
    return (null)
  } else
    return (
      <div>
        <div className="Home">



          <div className="banner_slider_wrapper">
            <Slider {...sliderSettings} className="banner_slider banner_slider_3 banner_slider_3_overlay">
              <div className="slide">
                <div
                  className="slide_img"
                  style={{
                    backgroundImage: `url(${require("../assets/FrontOffice/images/miel2.jpg")})`,
                  }}
                ></div>
                <div className="slide__content padding_top90 res-1199-padding_top0">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="slide__content--headings ttm-textcolor-white">
                          <div className="left-content">
                            <h2 data-animation="fadeInDown">
                              <span>{t("HomeSpan1.1")}</span>
                            </h2>
                            <p
                              data-animation="fadeInDown"
                              className="padding_right40"
                            >
                              <span style={{ fontSize: 20 }}>{t("HomeSpan2.1")}</span>
                            </p>
                            {!localStorage.getItem("id") && (
                              <div
                                className="d-inline-block margin_top30"
                                data-animation="fadeInUp"
                                data-delay="1.4"
                              >
                                <a
                                  className="ttm-btn ttm-btn-size-md ttm-btn-shape-rounded ttm-btn-style-fill ttm-btn-color-skincolor inscris-button"
                                  href="/inscription"
                                >
                                  {t("Home1.1")}
                                </a>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="slide">
                <div
                  className="slide_img"
                  style={{
                    backgroundImage: `url(${require("../assets/img/honey-bg2.jpg")})`,
                  }}
                ></div>
                <div className="slide__content padding_top90 res-1199-padding_top0">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="slide__content--headings ttm-textcolor-white">
                          <div className="left-content">
                            <h2 data-animation="fadeInDown">
                              <span>{t("homeSliderTitle2")}</span>
                            </h2>
                            <p
                              data-animation="fadeInDown"
                              className="padding_right40"
                            >
                              <span style={{ fontSize: 20 }}>{t("homeSlider2")}</span>
                            </p>
                            {!localStorage.getItem("id") && (
                              <div
                                className="d-inline-block margin_top30"
                                data-animation="fadeInUp"
                                data-delay="1.4"
                              >
                                <a
                                  className="ttm-btn ttm-btn-size-md ttm-btn-shape-rounded ttm-btn-style-fill ttm-btn-color-skincolor"
                                  href="/inscription"
                                >
                                  {t("Home1.1")}
                                </a>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
          <div className="site-main">

            <section className="ttm-row service-section  ttm-bgcolor-white clearfix">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">

                    <div className="section-title title-style-center_text">
                      <div className="title-header">

                        <h2 className="title">{t("Home2.1")}</h2>
                      </div>
                      <div className="title-desc">
                        <p style={{ fontSize: 18 }}></p>
                      </div>
                    </div>



                  </div>
                </div>


                <div className="row">
                  <div className="col-md-3 col-sm-6" >
                    <div className="itemSimpleCarte" >
                      <img src={require("../assets/FrontOffice/images/ic5.png")} style={{ with: 150, height: 100 }} />
                      <div className="margin-10">
                        <span style={{ color: "#0e204d", fontWeight: "bold" }}>{t("Home3.1")}</span>
                      </div>

                    </div>
                  </div>


                  <div className="col-md-3 col-sm-6" >
                    <div className="itemSimpleCarte">
                      <img src={require("../assets/FrontOffice/images/ic2.png")} style={{ with: 150, height: 100 }} />
                      <div className="margin-10">
                        <span style={{ color: "#0e204d", fontWeight: "bold" }}>{t("Home4.1")}</span>
                      </div>

                    </div>
                  </div>

                  <div className="col-md-3 col-sm-6" >
                    <div className="itemSimpleCarte">
                      <img src={require("../assets/FrontOffice/images/ic3.png")} style={{ with: 150, height: 100 }} />

                      <div className="margin-10">
                        <span style={{ color: "#0e204d", fontWeight: "bold" }}>{t("Home5.1")} </span>
                      </div>

                    </div>
                  </div>

                  <div className="col-md-3 col-sm-6" >
                    <div className="itemSimpleCarte">
                      <div>
                        <img src={require("../assets/FrontOffice/images/ic4.png")} style={{ with: 150, height: 100 }} />
                      </div>
                      <div className="margin-10">

                        <span style={{ color: "#0e204d", fontWeight: "bold" }}>{t("Home6.1")} </span>
                      </div>

                    </div>
                  </div>


                </div>

                <div className="section-title title-style-center_text">
                  <div className="title-desc margin-30">
                    <p style={{ fontSize: 18 }}>{t("Home7.1")}</p>
                  </div>
                </div>


              </div>
            </section>















            <section className="ttm-row service-section  ttm-bgcolor-grey clearfix">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">

                    <div className="section-title title-style-center_text">
                      <div className="title-header">

                        <h2 className="title">{t("Home8.1")}</h2>
                      </div>

                    </div>



                  </div>
                </div>


                <div className="row" style={{ marginTop: 20 }}>
                  <div className="col-md-3 col-sm-6" >
                    <div className="itemSimpleCarte" >
                      <img src={require("../assets/FrontOffice/images/tmoi4.png")} style={{ height: 80 }} />
                      <div className="margin-10">
                        <span style={{ color: "#000", fontWeight: "bold" }}>{t("Home9.1")}</span>
                        <p style={{ marginTop: 10 }}>{t("Home10.1")}</p>
                      </div>

                    </div>
                  </div>


                  <div className="col-md-3 col-sm-6" >
                    <div className="itemSimpleCarte">
                      <img src={require("../assets/FrontOffice/images/tmoi3.png")} style={{ height: 80 }} />
                      <div className="margin-10">
                        <span style={{ color: "#000", fontWeight: "bold" }}>{t("Home11.1")}</span>
                        <p style={{ marginTop: 10 }}>{t("Home12.1")}</p>
                      </div>

                    </div>
                  </div>

                  <div className="col-md-3 col-sm-6" >
                    <div className="itemSimpleCarte">
                      <img src={require("../assets/FrontOffice/images/tmoi2.png")} style={{ height: 80 }} />

                      <div className="margin-10">
                        <span style={{ color: "#000", fontWeight: "bold" }}>{t("Home13.1")}</span>
                        <p style={{ marginTop: 10 }}>{t("Home14.1")}</p>
                      </div>

                    </div>
                  </div>

                  <div className="col-md-3 col-sm-6" >
                    <div className="itemSimpleCarte">
                      <div>
                        <img src={require("../assets/FrontOffice/images/tmoi1.png")} style={{ height: 80 }} />
                      </div>
                      <div className="margin-10">

                        <span style={{ color: "#000", fontWeight: "bold" }}>{t("Home15.1")}</span>
                        <p style={{ marginTop: 10 }}>{t("Home16.1")}
                        </p>
                      </div>

                    </div>
                  </div>


                </div>




              </div>
            </section>








            {products.length ?
              <section className="ttm-row service-section ttm-bgcolor-white clearfix mb-3">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="section-title seemore">
                        <div className="title-header">
                          <h4 >{t("Home17.1")} </h4>
                        </div>


                        <div className="plus">
                          <span><a href="#" onClick={() => { navigate("/marketplace") }} >{t("Home18.1")}</a></span>
                        </div>
                      </div>
                    </div>



                    <div className="col-lg-12">
                      <div className="slick-slider-container" style={{ width: "90%", marginLeft: "auto", marginRight: "auto" }}>
                        <Slider {...{ ...sliderSettings, infinite: false, prevArrow: <CustomArrow />, nextArrow: <CustomArrow /> }} ref={(s) => (slider = s)}>
                          {products.map((product, index) => (

                            <div key={index} className="slick-slide" >
                              <div className=" ttm-box-col-wrapper" >

                                <div className="featured-imagebox featured-imagebox-portfolio style2" style={{ margin: "10px 45vh" }}>

                                  <div className="ttm-box-view-overlay">

                                    <div className="featured-thumbnail" >
                                      <img className="img-fluid" src={`${Global.backend}/uploads/${product.image[0].imageURL}`} style={{ marginLeft: "auto", marginRight: "auto" }} alt="image" />
                                    </div>
                                    <div className="ttm-media-link">
                                      <NavLink className="ttm_prettyphoto ttm_image" title="Cage System" data-rel="prettyPhoto" to={`/detailproduit/${product.id}`}>
                                        <i className="fa fa-search"></i>
                                      </NavLink>
                                    </div>
                                  </div>
                                  <div className="featured-content">
                                    <div className="featured-title">
                                      <h3><NavLink to={`/detailproduit/${product.id}`}>{product.nom}</NavLink></h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          ))}
                        </Slider>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              :
              ""
            }









            <section className="ttm-row about-section ttm-bgimage-yes bg-img1 ttm-bg ttm-bgcolor-darkgrey  clearfix">
              <div className="ttm-row-wrapper-bg-layer ttm-bg-layer"></div>
              <div className="container">

                <div className="row">
                  <div className="col-lg-12">
                    <div className="section-title title-style-center_text">
                      <div className="title-header">
                        <h2 style={{ fontSize: 24, color: "#fff", fontWeight: "bold" }}>{t("Home19.1")} </h2>
                      </div>
                    </div>
                  </div>
                </div>



                <div className="row">
                  <div className="col-lg-3 col-md-4 col-sm-6">

                    <div className="ttm-fid inside ttm-fid-view-lefticon style1">

                      <div className="ttm-fid-contents">
                        <h4 className="ttm-fid-inner">
                          <span data-appear-animation="animateDigits" data-from="0" data-to={8} data-interval="4" data-before="" data-before-style="sup" data-after="+" data-after-style="sub" className="numinate">{nbRegisteredCountries}</span>
                        </h4>
                        <h3 className="ttm-fid-title">{t("Home20.1")} </h3>
                      </div>
                    </div>
                  </div>




                  <div className="col-lg-3 col-md-4 col-sm-6">

                    <div className="ttm-fid inside ttm-fid-view-lefticon style1">

                      <div className="ttm-fid-contents">
                        <h4 className="ttm-fid-inner">
                          <span data-appear-animation="animateDigits" data-from="0" data-to={200} data-interval="4" data-before="" data-before-style="sup" data-after="+" data-after-style="sub" className="numinate">{nbRegisteredBusiness}</span>
                        </h4>
                        <h3 className="ttm-fid-title">{t("typecompte2.1")} </h3>
                      </div>
                    </div>
                  </div>




                  <div className="col-lg-3 col-md-4 col-sm-6">

                    <div className="ttm-fid inside ttm-fid-view-lefticon style1">

                      <div className="ttm-fid-contents">
                        <h4 className="ttm-fid-inner">
                          <span data-appear-animation="animateDigits" data-from="0" data-to={300} data-interval="4" data-before="" data-before-style="sup" data-after="+" data-after-style="sub" className="numinate">{nbOrders}</span>
                        </h4>
                        <h3 className="ttm-fid-title">{t("Home22.1")} </h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 col-sm-6">

                    <div className="ttm-fid inside ttm-fid-view-lefticon style1">

                      <div className="ttm-fid-contents">
                        <h4 className="ttm-fid-inner">
                          <span data-appear-animation="animateDigits" data-from="0" data-to={300} data-interval="4" data-before="" data-before-style="sup" data-after="+" data-after-style="sub" className="numinate">{nbRegisteredBuyers}</span><span></span>
                        </h4>
                        <h3 className="ttm-fid-title"> {t("typecompte1.1")} </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>








            <section className="ttm-row testimonial-section clearfix">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-lg-12">
                    <div className="section-title seemore">
                      <div className="title-header">
                        <h4 >{t("Home24.1")} </h4>
                      </div>
                      <div className="plus">
                        <span ><a href="/annuaires">{t("Home25.1")}  </a></span>
                      </div>
                    </div>
                  </div>



                  {entrepriseList.map((entreprise, index) => (
                    <div key={index} className="col" >
                      <NavLink to={`/entreprise/${entreprise.nom}`}>
                        <img src={`${Global.backend}/uploads/${entreprise.logo}`} />
                      </NavLink>
                    </div>
                  ))}

                </div>
              </div>
            </section>





            <section className="ttm-row service-section ttm-bgcolor-grey clearfix">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">

                    <img
                      className="img-fluid"
                      src={require("../assets/FrontOffice/images/cap11.png")}
                      alt="single-01"
                      style={{

                        height: 350,
                        width: 290,
                        marginTop: -50

                      }}
                    />



                  </div>



                  <div className="col-lg-6">
                    <h2 className="title" style={{ fontSize: 22, fontWeight: "bold" }}>{t("Home26.1")} </h2>


                    <p style={{ fontSize: 18 }}>{t("Home27.1")} .</p>

                    <div className="row">
                      <div className="col-lg-6">
                        <img
                          className="img-fluid"
                          src={require("../assets/FrontOffice/images/play.png")}
                        />
                      </div>
                      <div className="col-lg-6">
                        <img
                          className="img-fluid"
                          src={require("../assets/FrontOffice/images/apple.png")}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>








            <section className="ttm-row client-section  clearfix" style={{ paddingTop: 120, marginBottom: 20 }}>
              <div className="container">

                <div className="section-title title-style-center_text">
                  <div className="title-header">

                    <h2 className="title" style={{ fontSize: 24 }}>{t("Home28.1")} </h2>
                  </div>

                </div>





                <div className="row">
                  <div className="col-lg-12">
                    <Slider {...config}>


                      <div className="client-box">
                        <div className="ttm-client-logo-tooltip">
                          <div className="ttm-client-logo-tooltip-inner">
                            <div className="client-thumbnail">
                              <img className="img-fluid" src={require("../assets/FrontOffice/images/association1.png")} alt="image" />
                            </div>
                            <div className="client-thumbnail_hover">
                              <img className="img-fluid" src={require("../assets/FrontOffice/images/association1.png")} alt="image" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="client-box">
                        <div className="ttm-client-logo-tooltip">
                          <div className="ttm-client-logo-tooltip-inner">
                            <div className="client-thumbnail">
                              <img className="img-fluid" src={require("../assets/FrontOffice/images/association2.png")} alt="image" />
                            </div>
                            <div className="client-thumbnail_hover">
                              <img className="img-fluid" src={require("../assets/FrontOffice/images/association2.png")} alt="image" />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="client-box">
                        <div className="ttm-client-logo-tooltip">
                          <div className="ttm-client-logo-tooltip-inner">
                            <div className="client-thumbnail">
                              <img className="img-fluid" src={require("../assets/FrontOffice/images/association3.png")} alt="image" />
                            </div>
                            <div className="client-thumbnail_hover">
                              <img className="img-fluid" src={require("../assets/FrontOffice/images/association3.png")} alt="image" />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="client-box">
                        <div className="ttm-client-logo-tooltip">
                          <div className="ttm-client-logo-tooltip-inner">
                            <div className="client-thumbnail">
                              <img className="img-fluid" src={require("../assets/FrontOffice/images/association4.png")} alt="image" />
                            </div>
                            <div className="client-thumbnail_hover">
                              <img className="img-fluid" src={require("../assets/FrontOffice/images/association4.png")} alt="image" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="client-box">
                        <div className="ttm-client-logo-tooltip">
                          <div className="ttm-client-logo-tooltip-inner">
                            <div className="client-thumbnail">
                              <img className="img-fluid" src={require("../assets/FrontOffice/images/association5.png")} alt="image" />
                            </div>
                            <div className="client-thumbnail_hover">
                              <img className="img-fluid" src={require("../assets/FrontOffice/images/association5.png")} alt="image" />
                            </div>
                          </div>
                        </div>
                      </div>








                    </Slider>

                  </div>
                </div>
              </div>
            </section>






            <section id="newsletter" className="clearfix bg-img">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="newsletter-content">
                      <h2>{t("Home29.1")} </h2>
                      <p>{t("Home30.1")} <br /> {t("Home31.1")}</p>
                    </div>
                  </div>
                  <div className="col-md-6" style={{ marginTop: 30 }}>
                    <div className="newsletter-form">
                      <form>

                        <input type="text" placeholder="Courriel" style={{ width: 300, marginRight: 10 }}></input>

                        <a
                          className="ttm-btn ttm-btn-size-md ttm-btn-shape-rounded ttm-btn-style-fill ttm-btn-color-skincolor inscris"
                          href="/inscription" style={{ backgroundColor: "#3f2414", borderColor: "#3f2414" }}
                        >
                          {t("Home32.1")}
                        </a>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </section>























          </div>
          <Footer />
        </div>
      </div>
    );
};

export default Home;
